import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceBrandingRoute: InvariantJiraRoute = {
	name: 'csm-experience-branding',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/branding',
	exact: true,
};
